/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import {
  BackButton,
} from '@marageti/z4-lib';
import {
  Box,
  Typography,
} from '@mui/material';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { DocumentType } from '@marageti/z4-sdk/lib/documents/Document';
import DocumentUploadForm from './doc-upload-form';
import useDocumentUpload from '../../../hooks/use-document-upload';

const typeMap = {
  'general-document': DocumentType.DocumentGeneral,
  'sample-itinerary': DocumentType.DocumentSampleItinerary,
};

const DocUpload = () => {
  const [submissionError, setSubmissionError] = useState<ApiError>();
  const { uploadURL, uploadFile } = useDocumentUpload();
  const { tripMatchId, documentType } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const mappedDocumentType = documentType ? typeMap[documentType as keyof typeof typeMap] : undefined;

  const handleError = (error: any) => {
    const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred';
    setSubmissionError({ message: errorMessage });
  };

  const onSubmitURL = async (data: any) => {
    setSubmissionError(undefined);
    try {
      if (tripMatchId && mappedDocumentType) {
        await uploadURL(data.sourceURI, tripMatchId, mappedDocumentType, data.title);
        if (documentType === 'general-document') {
          enqueueSnackbar('Your document has been saved.', { variant: 'success' });
        } else {
          enqueueSnackbar('Your itinerary has been saved.', { variant: 'success' });
        }
        navigate(-1);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const onSubmitFile = async (data: any) => {
    setSubmissionError(undefined);
    const file = data.document[0];
    const newFile = new File([file], data.title, { type: file.type });
    try {
      if (tripMatchId && mappedDocumentType) {
        await uploadFile(newFile, tripMatchId, mappedDocumentType, data.title);
        if (documentType === 'general-document') {
          enqueueSnackbar('Your document has been saved.', { variant: 'success' });
        } else {
          enqueueSnackbar('Your itinerary has been saved.', { variant: 'success' });
        }
        navigate(-1);
      }
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <Box sx={{ maxWidth: '558px', margin: '0 auto', px: 3 }}>
      <Box sx={{ pt: 1.5, pb: 1.5 }}>
        <BackButton
          aria-label="back to trip"
          sx={{
            position: 'relative',
            top: '0px',
            left: '0px',
            width: 'auto',
            height: 'auto',
            p: 0,
            m: 0,
          }}
        />
        <Typography variant="h2" width="100%" textAlign="left" position="relative" pt="20px">
          {documentType === 'general-document' && 'Upload Document'}
          {documentType === 'sample-itinerary' && 'New Itinerary'}
        </Typography>
      </Box>
      <DocumentUploadForm
        documentType={documentType}
        submissionError={submissionError}
        navigate={navigate}
        onSubmitFile={onSubmitFile}
        onSubmitURL={onSubmitURL}
      />
    </Box>
  );
};

export default DocUpload;
